import { removePreference } from './preferences'

function resetPreferences() {
  removePreference('lastVisitedPage')
}

export default resetPreferences
